import React from "react";
import { Modal } from "react-bootstrap";
import crossImage from "../../public/images/close.svg";
import styles from "../../Common/CommentModal/commentModal.module.css"
import { Button } from "../../Common";

function DeleteConfirmationModal({
    isOpen,
    onRequestClose,
    onConfirm,
    message,
    loading = false,
    showSuccess = false,
    successMessage = "Account deleted successfully!",
    errorMessage = ""
}) {
    return (
        <Modal
            show={isOpen}
            onHide={onRequestClose}
            className={`${styles.modalRight}`}
            centered
        >
            <Modal.Header>
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeading}>
                        Confirm Delete
                    </div>
                    <div id="crossImage">
                        <img src={crossImage} alt="" onClick={() => onRequestClose()} />
                    </div>
                </div>
            </Modal.Header>
            <Modal.Body id="modal-body">
                <div>
                    <div className={styles.modalBody}>
                        {message}
                    </div>
                    {errorMessage && (
                    <div style={{ color: "red", marginTop: "5px", fontSize: "14px" }}>
                        {errorMessage}
                    </div>
                    )}
                    {showSuccess && (
                        <div className={styles.modalSuccess}>
                            {successMessage}
                        </div>
                    )}

                    <div className={styles.modalButton}>
                        <Button
                            onClick={onRequestClose}
                            title={"Cancel"}
                            disabled={loading}
                        />
                        <Button
                            onClick={onConfirm}
                            title={"Confirm"}
                            loading={loading}
                            disabled={loading}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DeleteConfirmationModal;